module.exports = __webpack_public_path__ + "assets/delete.3ee03d59.svg";